/**
 * Coluna do Kanban Board
 */

import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { useDroppable } from '@dnd-kit/core';

interface KanbanColumnProps {
  id: string;
  title: string;
  color: string;
  children: React.ReactNode;
  stats: {
    totalGroups: number;
    totalLeads: number;
    contactado: number;
    recusou: number;
    semContato: number;
    emContato: number;
    fechado: number;
  };
}

const KanbanColumn: React.FC<KanbanColumnProps> = ({ id, title, color, children, stats }) => {
  const { setNodeRef, isOver } = useDroppable({
    id,
  });

  return (
    <Box
      ref={setNodeRef}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minWidth: 0, // Permite que o grid column controle a largura
      }}
    >
      {/* Column Header */}
      <Box
        sx={{
          p: 1.5,
          mb: 1.5,
          backgroundColor: '#1a1a1a',
          border: `2px solid ${color}`,
          borderRadius: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="h6" sx={{ color, fontWeight: 700, fontSize: '1.1rem' }}>
          {title}
        </Typography>
        <Chip
          label={`${stats.totalLeads} leads`}
          size="small"
          sx={{
            backgroundColor: `${color}20`,
            color: color,
            fontWeight: 700,
            fontSize: '0.85rem',
          }}
        />
      </Box>

      {/* Cards Container */}
      <Box
        sx={{
          flex: 1,
          overflowY: 'auto',
          p: 1,
          backgroundColor: isOver ? 'rgba(255, 107, 53, 0.05)' : 'rgba(255, 255, 255, 0.02)',
          border: isOver ? '2px dashed rgba(255, 107, 53, 0.5)' : '2px dashed rgba(255, 255, 255, 0.1)',
          borderRadius: 2,
          transition: 'all 0.2s ease',
          minHeight: '400px',
        }}
      >
        {children && (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            {children}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default KanbanColumn;
